export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtMernaJdn';
export const NAME = 'MernaJednotka';
